import { useEffect, RefObject } from 'react';

export function useHeaderHeight(elementRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    if (!elementRef || !elementRef.current) return;

    const observer = new ResizeObserver(entries => {
      Array.from(entries).forEach(entry => {
        const height =
          entry.borderBoxSize?.[0]?.blockSize ?? (entry.target as HTMLElement).offsetHeight;

        document.body.style.setProperty('--global-min-spend-height', `${height}px`);
      });
    });

    observer.observe(elementRef.current);

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect();
    };
  }, [elementRef]);
}
